import React from "react";
import { Box } from "@mui/material";
import DefaultToolbar from "../DataGrid/DefaultToolbar";
import moment from "moment";

export default function ReportToolbar({ companyName, reportTitle, children }) {
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    p: 2,
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    background: 'linear-gradient(270.01deg, #026999 36.65%, #FFFFFF 103.85%)'
                }}
            >
                <Box>
                    <h3>{companyName}</h3>
                </Box>
                <Box sx={{ color: 'white' }}>
                    <div style={{ fontSize: '25px', textAlign: 'right' }}>{reportTitle}</div>
                    <div style={{ fontSize: '15px', textAlign: 'right' }}>Report Date: {moment().format('MMMM Do YYYY, hh:mm A')}</div>
                </Box>
            </Box>
            {children}
            <Box sx={{
                '@media print': {
                    display: 'none !important',
                }
            }}>
                <DefaultToolbar />
            </Box>
        </Box>
    );
}
